import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { useLocation } from "react-router-dom";
import { addEspaceCharacters, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { useAuth } from "../Components/AuthContext";
import { LoaderBox } from "../Components/LoaderBox";

function CultivoEditar() {
  const { state } = useLocation();
  const { id } = state;
  const [isLoading, setLoading] = React.useState(true);
  const [openDialog, setOpenDialog] = React.useState(false);
  const { user } = useAuth();
  const [ cultivo, setCultivo ] = React.useState("");

  const [dialog, setDialog] = React.useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Cultivos",
    pageState: {},
  });

  if (isLoading) {
    console.log(id);
    instance
      .get("/cultivo/tipo/" + id)
      .then((res) => {
        console.log(res.data);
        setCultivo(res.data.Nombre);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally(
        setTimeout(() => {
          setLoading(false);
        }, 1000)
      );
  }

  const handleInputChange = (event) => {
    const { value } = event.target;
    setCultivo(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    console.log(info.nombre.value)
    let form = {
      id: id,
      nombre: addEspaceCharacters(info.nombre.value)
    };
    instance
      .put("/cultivo/updateTipo", form)
      .then((res) => {
        setDialog({
          title: "Actualización exitosa",
          text: `Se ha actualizado el nombre del cultivo de forma exitosa.`,
          redirect: true,
          page: "/Cultivos",
          //pageState: { id: catalogo.Id },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        component="main"
        maxWidth="xs"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 8,
        }}
      >
        <Grid
          container
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
          component="form"
          onSubmit={handleSubmit}
        >
          <Grid item>
            <TextField
              margin="normal"
              required
              fullWidth
              id="nombre"
              label="Nombre del cultivo"
              name="nombre"
              value={cultivo}
              autoFocus
              inputProps={{ maxLength: 100 }}
              onChange={handleInputChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              type="submit"
              size="medium"
              variant="contained"
              sx={{ mt: 3 }}
              color="success"
            >
              Actualizar
            </Button>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { CultivoEditar };
